module.exports = __webpack_public_path__ + "media/logos/lexshares-c8e179d7.png";